import { useRetailPriceField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const RetailPriceRow = () => {
    const { label, inputProps } = useRetailPriceField();
    const inputId = useScenarioCellId('retailPrice');

    return (
        <ScenarioRow rowKey="retailPrice" label={label} inputId={inputId}>
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
        </ScenarioRow>
    );
};
